// legalFormSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LegalFormState {
  name: string;
  display_name: string;
  national_id: string;
  address: string;
  postal_code: string;
  phone: string;
  [key: string]: string | number | undefined; 
  identity_type:string;
  id?: number;
}

const initialState: LegalFormState = {
  name: '',
  display_name: '',
  national_id: '',
  address: '',
  postal_code: '',
  phone: '',
  identity_type:'LEGAL',
  
};

const legalFormSlice = createSlice({
  name: 'legalForm',
  initialState,
  reducers: {
    updateLegalForm(state, action: PayloadAction<{ [key: string]: string }>) {
      Object.keys(action.payload).forEach((key) => {
        (state as any)[key] = action.payload[key];
      });
    },
    setId(state, action: PayloadAction<number>) {
      state.id = action.payload;
    },
  },
});

export const { updateLegalForm, setId } = legalFormSlice.actions;
export default legalFormSlice.reducer;
